import { axios } from "@/lib/axios";
import {TicketDestinations} from "@/components/Ticket/types";
import { SortPostParams } from "@/containers/admin/TicketDestinations/TicketDestinationList"

export const getTicketDestinations = (params: {[key: string]: SortPostParams}): Promise<any> => {
  return axios.post("/api/v1/ticketDestination/getAll", params);
};

export const addTicketDestination = (ticketDestination: TicketDestinations) => {
  return axios.post("/api/v1/ticketDestination/add", ticketDestination);
};

export const modifyTicketDestination = (ticketDestination: TicketDestinations) => {
  return axios.post("/api/v1/ticketDestination/edit", ticketDestination);
};

export const removeTicketDestination = (
  ticketDestination: TicketDestinations
) => {
  return axios.delete("/api/v1/ticketDestination/delete", {
    params: {
      id: ticketDestination.id,
    },
  });
};

export const getTicketDestinationBy = (project_id: number) => {
  return axios.get("/api/v1/ticketDestination/getByProjectId", {
    params: {
      project_id,
    },
  });
};
